import { render, staticRenderFns } from "./sme-kyc-form.vue?vue&type=template&id=6867e70b&scoped=true&"
import script from "./sme-kyc-form.vue?vue&type=script&lang=js&"
export * from "./sme-kyc-form.vue?vue&type=script&lang=js&"
import style0 from "./sme-kyc-form.vue?vue&type=style&index=0&id=6867e70b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6867e70b",
  null
  
)

export default component.exports